import React from "react";

const SecondaryHeading = ({ children }) => {
  return (
    <div className="flex items-center gap-2 ">
      <div className="max-sm:hidden">
        <p className="w-11 border border-primary"></p>
        <p className="w-6 border mt-[7px] border-primary"></p>
      </div>
      <h2 className="text-xl font-semibold text-textColor text-center max-sm:text-base">
        {children}
      </h2>
      <div className="max-sm:hidden">
        <p className="w-6 border border-primary"></p>
        <p className="w-11 border mt-[7px] border-primary"></p>
      </div>
    </div>
  );
};

export default SecondaryHeading;
